<script>
export default {
  name: 'visualizerPdfImage',
  props: {
    config: {
      type: Object,
      required: false,
      default: null,
    },
    file: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      imageSrc: null,
      typefile: null,
    }
  },
  mounted() {
    // console.log('Componente cargado')
    // console.log('props ',this.props)
  },
  computed: {
    hasImage() {
      if (this.file) {
        const acceptExtensions = this.config
          ? this.config.acceptExtensions.replaceAll('.', '').split(',')
          : ['png', 'jpg', 'svg', 'gif', 'webp', 'bmp']
        const typefile = this.file.split('.').pop()
        let isvalid = acceptExtensions.includes(typefile)
        return isvalid
      }
      return false
    },
    hasPdf() {
      if (this.file) {
        const acceptExtensions = ['pdf']
        const typefile = this.file.split('.').pop()
        let isvalid = acceptExtensions.includes(typefile)
        return isvalid
      }
      return false
    },
  },
  watch: {
    file(newValue, oldValue) {
      // console.log(newValue)
      if (newValue && this.hasImage) {
        if (newValue !== oldValue) {
          this.imageSrc = this.newValue 
        }
      } else if (newValue && this.hasPdf) {
        this.imageSrc = this.newValue 
      }
    },
  },
}
</script>

<template>
  <div>
    <embed
      v-if="hasPdf"
      type="application/pdf"
      :src="imageSrc"
      class="h-adjusted"
    />
    <b-img
      v-else-if="hasImage"
      :src="imageSrc"
      class="mb-3 h-adjusted"
      fluid
      block
      rounded
    ></b-img>
  </div>
</template>
<style scoped="scss">
.h-adjusted {
  height: 200px;
  width: 90%;
}
</style>

